import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import Modify from '../pages/Modify';
import Forget from '../pages/Forget';

import Order from '../pages/Order'
import Service from '../pages/Service'
import NewMachine from '../pages/NewMachine'
import NewMachinePro from '../pages/NewMachinePro'
import IPService from '../pages/IPService'
import IPServicePro from '../pages/IPServicePro'
import Buy from '@/pages/Buy'
import Home from '../pages/Home';
import RenderMarkdown from '../docs/RenderMarkdown';
import Site from '@/pages/Site';
import CloudPhone from '@/pages/CloudPhone';
import Synchronization from '@/pages/Synchronization'
import Renewal from '@/pages/Renewal'
import WeixinPay from '@/pages/WeixinPay'
import Stop from '@/pages/Stop'

export default [
  {
    path: '/docs',
    Component: RenderMarkdown,
    name: 'docs',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/',
    Component: SignIn,
    name: 'SignIn',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/SignUp',
    Component: SignUp,
    name: 'SignUp',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/Forget',
    Component: Forget,
    name: 'Forget',
    exact: true,
    hideInMenu: true
  },

  {
    path: '/Home',
    Component: Home,
    name: 'Home',
    hideInMenu: true,
    routes: [
      {
        path: '/Home/Order',
        Component: Order,
        name: 'Order',
        exact: true,
        hideInMenu: false
      },
      {
        path: '/Home/CloudPhone',
        Component: CloudPhone,
        name: 'CloudPhone',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/Modify',
        Component: Modify,
        name: 'Modify',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/Vas',
        Component: Service,
        name: 'Service',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/NewMachine',
        Component: NewMachine,
        name: 'NewMachine',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/IPService',
        Component: IPService,
        name: 'IPService',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/NewMachinePro',
        Component: NewMachinePro,
        name: 'NewMachinePro',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/IPServicePro',
        Component: IPServicePro,
        name: 'IPServicePro',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/Buy',
        Component: Buy,
        name: 'Buy',
        exact: true,
        hideInMenu: true
      },
      {
        path: '/Home/Renewal',
        Component: Renewal,
        name: 'Renewal',
        exact: true,
        hideInMenu: true
      }
    ]
  },
  {
    path: '/Order',
    Component: Order,
    name: 'Order',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/Site',
    Component: Site,
    name: 'Site',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/Synchronization',
    Component: Synchronization,
    name: 'Synchronization',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/WeixinPay/:price/:orderCode/:erweima',
    Component: WeixinPay,
    name: 'WeixinPay',
    exact: true,
    hideInMenu: true
  },
  {
    path: '/stop',
    Component: Stop,
    exact: true,
    hideInMenu: true
  }
];
